import React from 'react';
import { Modal } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import HistoryCards from '../SplitRevisionHistory/HistoryCards';
import styles from './RevisionHistoryModal.css';

type Props = {
    ruleId: string;
    level: HistoryRulesParams['level'];
    openModal: boolean;
    subjectIdentifier?: string;
    listData?: ListManagementApiList[];
    setOpenModal: (open: boolean) => void;
    title: string;
};

const RevisionHistoryModal = ({
    ruleId,
    openModal,
    setOpenModal,
    level,
    subjectIdentifier,
    listData,
    title
}: Props) => {
    const { t } = useTranslation();
    return (
        <Modal
            closeOnClickOutside
            isOpen={openModal}
            closeModal={() => setOpenModal(false)}
            center
            containerClass={styles.modalContainer}
        >
            <Modal.Title
                title={title}
                id='revision-history-modal-title'
                onClose={() => setOpenModal(false)}
                showCloseIcon={false}
            />

            <div className={styles.historyCardsWrapper}>
                <HistoryCards
                    subjectIdentifier={subjectIdentifier}
                    level={level}
                    ruleId={ruleId}
                    listData={listData}
                    expanded={openModal}
                />
            </div>

            <Modal.Footer
                id='reivision-history-modal-footer'
                onClose={() => setOpenModal(false)}
                onAction={() => setOpenModal(false)}
                onActionText={t('Close')}
                onCloseText=''
            />
        </Modal>
    );
};

export default RevisionHistoryModal;
